import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Descriptions = _resolveComponent("Descriptions")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        _createVNode(_component_Descriptions, {
          data: _ctx.list,
          size: 'small',
          info: _ctx.info,
          bordered: true
        }, null, 8, ["data", "info"])
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}